<script>
    export let title;
    export let back_button_enabled;
    export let back_button_click_action;
    export let icon_class_name;

    import { mobile_menu_toggle } from "../../store/mobile_menu_toggle.js";

    const toggleMobileMenu = () => {
        if ($mobile_menu_toggle != "1" && $mobile_menu_toggle != "0") {
            mobile_menu_toggle.set("1");
        } else {
            mobile_menu_toggle.set($mobile_menu_toggle == "0" ? "1" : "0");
        }
    };
</script>

<div class="settings-heading">
    <div class="d-md-block">
        <div class="heading-block">
            <a
                class="nav-opener"
                href="#a"
                on:click={() => {
                    toggleMobileMenu();
                }}><i class="icon icon-navigation" /></a
            ><a class="nav-back" href="#b">
                {#if back_button_enabled}
                    <div class="ico-holder" on:click={back_button_click_action}>
                        <i class="icon icon-chevron-left" />
                    </div>
                {/if}
                {#if icon_class_name}
                    <div class="ico-holder">
                        <i class="icon {icon_class_name}" />
                    </div>
                {/if}
                <div class="title-holder">
                    <strong class="settings-title">{title}</strong>
                </div></a
            >
        </div>
    </div>
    <!--<div class="d-none d-md-block">
        <div class="heading-block">
            <h1 class="h6 settings-title">{title}</h1>
        </div>
    </div>
    -->
</div>
